import Types from "../actions/types";

export const defaultState = {
	data: [],
	isLoadingList: false
};

const reducer = (state = defaultState, action) => {
	switch (action.type) {
		case Types.EQUIPMENT_LIST_REQUESTED:
			return {
				...state,
				isLoadingList: true
			};
		case Types.EQUIPMENT_LIST_SUCCEEDED:
			return {
				...state,
				data: action.payload,
				isLoadingList: false
			};
		case Types.EQUIPMENT_UPDATE_SUCCEEDED: {
			const updated = action.payload;
			if (!updated?.id) {
				return state;
			}
			return {
				...state,
				data: (state.data || []).map((item) =>
					item.id === updated.id ? { ...item, ...updated } : item
				)
			};
		}
		case Types.EQUIPMENT_CREATE_SUCCEEDED: {
			const created = action.payload;
			if (!created?.id) {
				return state;
			}
			return {
				...state,
				data: [created, ...(state.data || []).filter((item) => item.id !== created.id)]
			};
		}
		default:
			return state;
	}
};

export default reducer;
